<h4 style="text-align: center; margin-bottom: 5%; margin-top: 5%;">Διαχείριση Υποψηφίων</h4>

<ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item">
        <a class="nav-link" [ngClass]="{active:selectedTab === 'pending'}" id="pending-tab" data-toggle="tab" (click)="changeTabOption('pending')" href="#pending" role="tab" aria-controls="pending" aria-selected="true">Εκκρεμείς</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" [ngClass]="{active:selectedTab === 'approved'}" id="approved-tab" data-toggle="tab" (click)="changeTabOption('approved')" href="#approved" role="tab" aria-controls="approved" aria-selected="false">Εγκεκριμένοι</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" [ngClass]="{active:selectedTab === 'disapproved'}" id="disapproved-tab" data-toggle="tab" (click)="changeTabOption('disapproved')" href="#disapproved" role="tab" aria-controls="disapproved" aria-selected="false">Απορριφθέντες</a>
    </li>
</ul>

<div class="tab-content" id="myTabContent">
    <!-- pending candidates -->
    <div *ngIf="candidatesData" class="tab-pane fade show" [ngClass]="{active:selectedTab === 'pending'}" id="pending" role="tabpanel" aria-labelledby="home-tab">
        <table id="candidatesTable" *ngIf="candidatesData" class="table">
            <thead>
                <tr class="table-success">
                    <th class="th-content" style="width: 5%;">
                        <label *ngIf="candidatesData.length > 0" class="checkBoxContainer">
                            <input class="checkBoxInputs" type="checkbox" [checked]="isAllSelected"
                                (change)="onCheckboxChangeSelectAll($event)" />
                            <span class="checkmark"></span>
                        </label></th>
                    <th class="th-content" style="width: 10%;">Όνομα</th>
                    <th class="th-content" style="width: 10%;">Επώνυμο</th>
                    <th class="th-content th-email" style="width: 16%;">Email</th>
                    <th class="th-content" style="width: 10%;">Φύλο</th>
                    <th class="th-content" style="width: 15%;">Επαγγελματική δραστηριότητα</th>
                    <th class="th-content" style="width: 10%;">Ημ/νια γέννησης</th>
                    <th class="th-content" style="width: 10%;">Προφίλ</th>
                    <th class="th-content" style="width: 14%;">Κατάσταση</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let candidate of candidatesData">
                    <td> <label class="checkBoxContainer">
                            <input class="checkBoxInputs" type="checkbox" [checked]="candidate.selected"
                                [value]="candidate.keycloakId" (change)="onCheckboxChange($event)" />
                            <span class="checkmark"></span>
                        </label> </td>
                    <td *ngIf="candidate.firstName; else notExists">{{candidate.firstName}}</td>
                    <td *ngIf="candidate.lastName; else notExists">{{candidate.lastName}}</td>
                    <td><a class="wrap-email" href="mailto:{{candidate.email}}">
                            {{candidate.email}}</a></td>
                    <td *ngIf="candidate.gender==='female'">Γυναίκα</td>
                    <td *ngIf="candidate.gender==='male'">Άνδρας</td>
                    <td *ngIf="!candidate.gender">-</td>
                    <td *ngIf="candidate.headline; else notExists">{{candidate.headline}}</td>
                    <td *ngIf="candidate.birthDate; else notExists">{{candidate.birthDate}}</td>
                    <td *ngIf="candidate.gender; else notExists" class="link" (click)="candidateProfile(candidate.keycloakId)">
                        Περισσότερες Πληροφορίες
                    </td>
                    <ng-template #notExists>
                        <td>-</td>
                    </ng-template>
                    <td style="width: 100%;">
                        <select (change)="onChange($event, candidate.keycloakId)" class="form-control" id="sel1" name="sellist1" style="width: max-content;">
                            <option value="pending" selected>Εκκρεμής</option>
                            <option value="approved">Εγκρίνεται</option>
                            <option value="disapproved">Απορρίπτεται</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
        <p *ngIf="candidatesData.length===0" style="margin-top: 20px;"> {{message}}</p>

        <div *ngIf="candidatesData.length>0" class="container handlingmultiplebuttons">
            <div class="row ">
                <div class="col-md-4 col-12 text-center ">
                    <button type="button" (click)="confirmModal('approved')" class="btn btn-approve btn-width">Έγκριση
                        επιλεγμένων</button>
                </div>

                <div class="col-md-4 offset-md-4 col-12 text-center ">
                    <button type="button" (click)="confirmModal('disapproved')" class="btn btn-disapprove btn-width">Απόρριψη
                        επιλεγμένων</button>
                </div>
            </div>
        </div>
    </div>

    <!-- approved candidates -->
    <div *ngIf="candidatesData" class="tab-pane fade show" [ngClass]="{active:selectedTab === 'approved'}" id="approved" role="tabpanel" aria-labelledby="profile-tab">

        <table id="candidatesTable" class="table">
            <thead>
                <tr>
                    <th class="th-content" style="width: 10%;">Όνομα</th>
                    <th class="th-content" style="width: 10%;">Επωνυμο</th>
                    <th class="th-content th-email" style="width: 17%;">Email</th>
                    <th class="th-content" style="width: 10%;">Φυλο</th>
                    <th class="th-content" style="width: 18%;">Επαγγελματικη δραστηριοτητα</th>
                    <th class="th-content" style="width: 10%;">Ημ/νια γεννησης</th>
                    <th class="th-content" style="width: 10%;">Προφιλ</th>
                    <th class="th-content" style="width: 15%;"> Κατασταση</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let candidate of candidatesData">
                    <td *ngIf="candidate.firstName; else notExists">{{candidate.firstName}}</td>
                    <td *ngIf="candidate.lastName; else notExists">{{candidate.lastName}}</td>
                    <td><a class="wrap-email" href="mailto:{{candidate.email}}">{{candidate.email}}</a></td>
                    <td *ngIf="candidate.gender==='female'">Γυναίκα</td>
                    <td *ngIf="candidate.gender==='male'">Άνδρας</td>
                    <td *ngIf="!candidate.gender">-</td>
                    <td *ngIf="candidate.headline; else notExists">{{candidate.headline}}</td>
                    <td *ngIf="candidate.birthDate; else notExists">{{candidate.birthDate}}</td>
                    <td *ngIf="candidate.gender; else notExists" class="link" (click)="candidateProfile(candidate.keycloakId)">
                        Περισσότερες Πληροφορίες
                    </td>
                    <ng-template #notExists>
                        <td>-</td>
                    </ng-template>
                    <td style="width: 100%;">
                        <select (change)="onChange($event, candidate.keycloakId)" class="form-control" id="sel1" name="sellist1" style="width: max-content;">
                            <option value="pending">Εκκρεμής</option>
                            <option value="approved" selected>Εγκεκριμένος</option>
                            <option value="disapproved">Απορρίπτεται</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
        <p *ngIf="candidatesData.length===0" style="margin-top: 20px;"> {{message}}</p>
    </div>

    <!-- dissaproved candidates -->
    <div *ngIf="candidatesData" class="tab-pane fade show" [ngClass]="{active:selectedTab === 'disapproved'}" id="disapproved" role="tabpanel" aria-labelledby="contact-tab">
        <table id="candidatesTable" class="table">
            <thead>
                <tr>
                    <th class="th-content" style="width: 10%;">Όνομα</th>
                    <th class="th-content" style="width: 10%;">Επωνυμο</th>
                    <th class="th-content th-email" style="width: 17%;">Email</th>
                    <th class="th-content" style="width: 10%;">Φυλο</th>
                    <th class="th-content" style="width: 18%;">Επαγγελματικη δραστηριοτητα</th>
                    <th class="th-content" style="width: 10%;">Ημ/νια γεννησης</th>
                    <th class="th-content" style="width: 10%;">Προφιλ</th>
                    <th class="th-content" style="width: 15%;">Κατασταση</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let candidate of candidatesData">
                    <td *ngIf="candidate.firstName; else notExists">{{candidate.firstName}}</td>
                    <td *ngIf="candidate.lastName; else notExists">{{candidate.lastName}}</td>
                    <td><a class="wrap-email" href="mailto:{{candidate.email}}">
                            {{candidate.email}}</a></td>
                    <td *ngIf="candidate.gender==='female'">Γυναίκα</td>
                    <td *ngIf="candidate.gender==='male'">Άνδρας</td>
                    <td *ngIf="!candidate.gender">-</td>
                    <td *ngIf="candidate.headline; else notExists">{{candidate.headline}}</td>
                    <td *ngIf="candidate.birthDate; else notExists">{{candidate.birthDate}}</td>
                    <td *ngIf="candidate.gender; else notExists" class="link" (click)="candidateProfile(candidate.keycloakId)">
                        Περισσότερες Πληροφορίες
                    </td>
                    <ng-template #notExists>
                        <td>-</td>
                    </ng-template>
                    <td style="width: 100%;">
                        <select (change)="onChange($event, candidate.keycloakId)" class="form-control" id="sel1" name="sellist1" style="width: max-content;">
                            <option value="pending">Εκκρεμής</option>
                            <option value="approved">Εγκρίνεται</option>
                            <option value="disapproved" selected>Απορρίφθηκε</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
        <p *ngIf="candidatesData.length===0" style="margin-top: 20px;"> {{message}}</p>
    </div>

    <!-- Pagination-->
    <app-pagination-bs *ngIf="candidateSearchResults" [initialPage]="currentPage + 1" [pageSize]="pageSize" [items]="candidateSearchResults" (changePage)="onChangePage($event)"></app-pagination-bs>
</div>



<!-- modal with candidate's full data -->
<div class="modal fade" id="candidateDataModal" tabindex="-1 " role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 700px;" role="document">
        <div *ngIf="candidateData" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel ">Στοιχεία Υποψηφίου</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <!-- contact Info -->
                <div *ngIf="candidateData">
                    <span class="font-color">Στοιχεία Επικοινωνίας</span>
                    <div class="list-group">
                        <a *ngIf="candidateData.address" class="list-group-item disabled"><span
                                class="font-color">Διεύθυνση κατοικίας: </span>{{candidateData.address}}</a>
                        <a *ngIf="candidateData.city" class="list-group-item disabled"><span class="font-color">Περιοχή:
                            </span>{{candidateData.city}}</a>
                        <a *ngIf="candidateData.postcode" class="list-group-item disabled"><span
                                class="font-color">T.K.: </span>{{candidateData.postcode}}</a>
                        <a *ngIf="candidateData.prefectureName" class="list-group-item disabled"><span
                                class="font-color">Νομός: </span>{{candidateData.prefectureName}}</a>
                        <br />
                    </div>
                </div>
                <div class="list-group">
                    <div *ngIf="candidateData.linkedInUrl"><span class="font-color">LinkedIn</span>
                        <a href="{{candidateData.linkedInUrl}}" class="list-group-item">
                            {{candidateData.linkedInUrl}}</a>
                    </div>
                    <div *ngIf="candidateData.facebookUrl"><span class="font-color">Facebook</span>
                        <a *ngIf="candidateData.facebookUrl" href="{{candidateData.facebookUrl}}" class="list-group-item">
                            {{candidateData.facebookUrl}}</a>
                    </div>
                    <div *ngIf="candidateData.cellphone"> <span class="font-color">Κινητό</span>
                        <a *ngIf="candidateData.cellphone" href="tel:+{{candidateData.cellphone}}" class="list-group-item">
                            {{candidateData.cellphone}}</a>
                    </div>
                    <div *ngIf="candidateData.phoneNumber"> <span class="font-color">Τηλέφωνο επικοινωνίας</span>
                        <a *ngIf="candidateData.phoneNumber" href="tel:+{{candidateData.phoneNumber}}" class="list-group-item">
                            {{candidateData.phoneNumber}}</a>
                    </div>
                    <div *ngIf="candidateData.fax"> <span class="font-color">Fax</span>
                        <a *ngIf="candidateData.fax" href="fax:{{candidateData.fax}}" class="list-group-item">
                            {{candidateData.fax}}</a>
                    </div>
                </div>

                <!-- CV -->
                <div *ngIf="candidateData.cvId">
                    <br /> Βιογραφικό σημείωμα
                    <div class="list-group">
                        <a class="list-group-item" (click)="downLoadCv(candidateData.keycloakId)" [href]="fileUrl">
                            <i class="fa fa-download"></i> {{candidateData.cvId}}</a>
                    </div>
                </div>

                <!-- general info -->
                <div *ngIf="candidateData">
                    <br />
                    <span class="font-color">Γενικές Πληροφορίες</span>
                    <div class="list-group">
                        <a *ngIf="candidateData.currentEmploymentType==='unemployed'" class="list-group-item disabled"><span class="font-color">Κατάσταση απάσχολησης:
                            </span>Άνεργος</a>
                        <a *ngIf="candidateData.currentEmploymentType==='part_time'" class="list-group-item disabled"><span class="font-color">Κατάσταση απάσχολησης:
                            </span>Μερική απασχόληση</a>
                        <a *ngIf="candidateData.currentEmploymentType==='full_time'" class="list-group-item disabled"><span class="font-color">Κατάσταση απάσχολησης:
                            </span>Πλήρης απασχόληση</a>
                        <a *ngIf="candidateData.afm" class="list-group-item disabled"><span class="font-color">ΑΦΜ:
                            </span>{{candidateData.afm}}</a>
                        <a *ngIf="candidateData.birthplace" class="list-group-item disabled"><span
                                class="font-color">Τόπος γέννησης: </span>{{candidateData.birthplace}}</a>
                        <a *ngIf="candidateData.birthDate" class="list-group-item disabled"><span
                                class="font-color">Ημ/νια γέννησης: </span>{{candidateData.birthDate}}</a>
                        <a *ngIf="candidateData.gender==='male'" class="list-group-item disabled"><span
                                class="font-color">Φύλο: </span>Άνδρας</a>
                        <a *ngIf="candidateData.gender==='female'" class="list-group-item disabled"><span
                                class="font-color">Φύλο: </span>Γυναίκα</a>
                        <a *ngIf="candidateData.maritalStatus==='married'" class="list-group-item disabled"><span
                                class="font-color">Οικογενειακή κατάσταση: </span>Άγαμος</a>
                        <a *ngIf="candidateData.maritalStatus==='unmarried'" class="list-group-item disabled"><span
                                class="font-color">Οικογενειακή κατάσταση: </span>Έγγαμος</a>
                        <a *ngIf="candidateData.maritalStatus==='divorced'" class="list-group-item disabled"><span
                                class="font-color">Οικογενειακή κατάσταση: </span>Διαζευγένος</a>
                        <a *ngIf="candidateData.numberOfChildren" class="list-group-item disabled"><span
                                class="font-color">Παιδιά: </span>{{candidateData.numberOfChildren}}</a>
                        <a *ngIf="candidateData.gender==='male' && candidateData.completedMilitaryService" class="list-group-item disabled"><span class="font-color">Στρατιωτικές υποχρεώσεις:
                            </span>Εκπληρωμένες</a>
                        <a *ngIf="candidateData.gender==='male' && !candidateData.completedMilitaryService" class="list-group-item disabled"><span class="font-color">Στρατιωτικές υποχρεώσεις:
                            </span>Μη εκπληρωμένες</a>
                        <br />
                    </div>
                </div>

                <!-- CV Info -->
                <div *ngIf="candidateData">
                    <br /> <span class="font-color">Στοιχεία Βιογραφικού </span>
                    <div class="list-group">
                        <a *ngIf="candidateData.headline" class="list-group-item disabled"><span
                                class="font-color">Επαγγελματική δραστηριότητα: </span>{{candidateData.headline}}</a>
                        <a class="list-group-item disabled"><span class="font-color">Χρόνια προϋπηρεσίας:
                            </span>{{candidateData.yearsOfWork_experience}}</a>
                        <a *ngIf="candidateData.hasComputerSkills" class="list-group-item disabled"><span
                                class="font-color">Γνώσεις Η/Υ: </span>Ναι</a>
                        <a *ngIf="!candidateData.hasComputerSkills" class="list-group-item disabled"><span
                                class="font-color">Γνώσεις Η/Υ: </span>Όχι</a>
                        <a *ngIf="candidateData.hasUnemploymentCard" class="list-group-item disabled"><span
                                class="font-color">Κάρτα ανεργίας από ΟΑΕΔ: </span>Ναι</a>
                        <a *ngIf="!candidateData.hasUnemploymentCard" class="list-group-item disabled"><span
                                class="font-color">Κάρτα ανεργίας από ΟΑΕΔ: </span>Όχι</a>
                        <a *ngIf="candidateData.hasSpecialNeeds" class="list-group-item disabled"><span
                                class="font-color">Κατηγορία ειδικών αναγκών: </span>Ναι</a>
                        <a *ngIf="!candidateData.hasSpecialNeeds" class="list-group-item disabled"><span
                                class="font-color">Κατηγορία ειδικών αναγκών: </span>Όχι</a>
                        <a *ngIf="candidateData.educationLvlId" class="list-group-item disabled"><span
                                class="font-color">Βαθμίδα εκπαίδευσης:
                            </span>{{candidateData.educationLvlName}}</a>
                        <br />
                    </div>
                </div>

                <!-- work experience -->
                <div *ngIf="candidateData.candidateExperienceWork && candidateData.candidateExperienceWork.length> 0">
                    <br /> <span class="font-color">Eπαγγελματική Εμπειρία</span>
                    <div *ngFor="let experience of candidateData.candidateExperienceWork" class="list-group">
                        <a *ngIf="experience.role" class="list-group-item disabled"><span class="font-color">Θέση
                                εργασίας:</span> {{experience.role}}</a>
                        <a *ngIf="experience.company" class="list-group-item disabled"><span class="font-color">Επωνυμία
                                εταιρείας:</span> {{experience.company}}</a>
                        <a *ngIf="experience.yearStart" class="list-group-item disabled"><span class="font-color">Έτος
                                έναρξης συνεργασίας:</span> {{experience.yearStart}}</a>
                        <a *ngIf="experience.yearEnd" class="list-group-item disabled"><span class="font-color">Έτος
                                λήξης συνεργασίας:</span> {{experience.yearEnd}}</a>
                        <br />
                    </div>
                </div>

                <!-- languages -->
                <div *ngIf="candidateData.candidateLanguages && candidateData.candidateLanguages.length> 0">
                    <br /> <span class="font-color">Ξένες Γλώσσες</span>
                    <div *ngFor="let language of candidateData.candidateLanguages" class="list-group">
                        <a *ngIf="language.degreeTitle" class="list-group-item disabled"><span
                                class="font-color">Τίτλος πτυχίου: </span>{{language.degreeTitle}}</a>
                        <a *ngIf="language.languageName" class="list-group-item disabled"><span
                                class="font-color">Γλώσσα: </span>{{language.languageName}}</a>
                        <a class="list-group-item disabled" *ngIf="language.degreeLevel && language.degreeLevel==='basic'"><span
                                class="font-color">Επίπεδο:</span> Βασικός Χρήστης</a>
                        <a class="list-group-item disabled" *ngIf="language.degreeLevel && language.degreeLevel==='proficient'"><span
                                class="font-color">Επίπεδο:</span> Ικανός Χρήστης</a>
                        <a class="list-group-item disabled" *ngIf="language.degreeLevel && language.degreeLevel==='independent'"><span
                                class="font-color">Επίπεδο:</span> Ανεξάρτητος Χρήστης</a>
                        <a *ngIf="language.comments" class="list-group-item disabled"><span class="font-color">Σχόλια:
                            </span>{{language.comments}}</a>
                        <br />
                    </div>
                </div>

                <!-- Seminars -->
                <div *ngIf="candidateData.candidateSeminars && candidateData.candidateSeminars.length> 0">
                    <br /> <span class="font-color">Επιμόρφωση / Σεμινάρια</span>
                    <div *ngFor="let seminar of candidateData.candidateSeminars" class="list-group">
                        <a *ngIf="seminar.organisation" class="list-group-item disabled"><span
                                class="font-color">Οργανισμός: </span>{{seminar.organisation}}</a>
                        <a *ngIf="seminar.program_title" class="list-group-item disabled"><span
                                class="font-color">Τίτλος προγράμματος: </span>{{seminar.program_title}}</a>
                        <a *ngIf="seminar.program_duration" class="list-group-item disabled"><span
                                class="font-color">Διάρκεια προγράμματος: </span>{{seminar.program_duration}}</a>
                        <a *ngIf="seminar.is_certificated" class="list-group-item disabled"><span
                                class="font-color">Βεβαίωση παρακολούθησης: </span>Ναι</a>
                        <a *ngIf="!seminar.is_certificated" class="list-group-item disabled"><span
                                class="font-color">Βεβαίωση παρακολούθησης: </span>Όχι</a>
                        <a *ngIf="seminar.comments" class="list-group-item disabled"><span class="font-color">Σχόλια:
                            </span>{{seminar.comments}}</a>
                        <br />
                    </div>
                </div>

                <!-- education -->
                <div *ngIf="candidateData.candidateEducation && candidateData.candidateEducation.length > 0">
                    <span class="font-color">Εκπαίδευση</span>
                    <div class=" list-group">
                        <div *ngFor="let education of candidateData.candidateEducation">
                            <a *ngIf="education.degree" class="list-group-item disabled"><span
                                    class="font-color">Πτυχίο: </span>{{education.degree}}</a>
                            <a *ngIf="education.degree_rate" class="list-group-item disabled"><span
                                    class="font-color">Βαθμός Πτυχίου: </span>{{education.degree_rate}}</a>
                            <a *ngIf="education.university" class="list-group-item disabled"><span
                                    class="font-color">Εκπαιδευτικό Ίδρυμα: </span>{{education.university}}</a>
                            <a *ngIf="education.educationLvlName" class="list-group-item disabled"><span
                                    class="font-color">Βαθμίδα εκπαίδευσης:
                                </span>{{education.educationLvlName}}</a>
                            <a *ngIf="education.yearStart" class="list-group-item disabled"><span
                                    class="font-color">Έτος εισαγωγής: </span>{{education.yearStart}}</a>
                            <a *ngIf="education.yearEnd" class="list-group-item disabled"><span class="font-color">Έτος
                                    απόκτησης πτυχίου: </span>{{education.yearEnd}}</a>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- confirm create admin modal -->
<div class="modal fade" id="confirmModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{titleMessage}}</h5>

                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <h5 class="modal-title" id="exampleModalLabel"></h5>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {{bodyMessage}}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Ακύρωση</button>
                <button type="button" (click)="handlingMultipleProfiles(selectedStatus)" class="btn btn-primary">Επιβεβαιωση</button>
            </div>
        </div>
    </div>
</div>